var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 .469c.516 0 .934.418.934.933V6.07H12.6a.933.933 0 010 1.866H7.934v4.667a.933.933 0 01-1.867 0V7.935H1.4a.933.933 0 010-1.866h4.667V1.402c0-.515.418-.933.933-.933z",
    fill: "#141414"
  })));
}
export default SvgPlus;